import React from "react";
import moment from "moment";
import { useTheme } from "@mui/material";

interface IWeekDayHeaderProps {
    shortest?: boolean;
}

export default function WeekDayHeader(props: IWeekDayHeaderProps) {
    const theme = useTheme();
    const weekdayshort = props.shortest
        ? moment.weekdaysMin()
        : moment.weekdaysShort();
    return (
        <>
            {weekdayshort.map((day) => (
                <th key={day}>
                    <div
                        style={{
                            height: "14px",
                            width: "32px",
                            opacity: "0.25",
                            color: theme.palette.text.primary,
                            fontFamily: theme.typography.fontFamily,
                            fontSize: "10px",
                            fontWeight: "bold",
                            lineHeight: "14px",
                            textAlign: "center",
                        }}
                    >
                        {day}
                    </div>
                </th>
            ))}
        </>
    );
}
